export default {
  name: "general",
  component: () => import("@/modules/general/layouts/GeneralLayout.vue"),
  children: [
    {
      path: "/",
      name: "HomeView",
      component: () => import("@/modules/general/views/HomeView.vue"),
    },
    {
      path: "/validaConstancia/:id(\\S+)",
      name: "validarConstancia",
      component: () => import("@/modules/general/views/ValidaConstancia.vue"),
    },
  ]
};
